<script>
    import _            from 'lodash'
    import { createEventDispatcher } from 'svelte'
    import { fade }     from 'svelte/transition'
    import * as files   from 'file-saver'
    import * as api     from '../../shared/api.js'
    import Modal        from '../../shared/SemanticModal.svelte'
    import Dropdown     from '../../shared/Dropdown.svelte'
    import Duration     from './Duration.svelte'

    export let domain
    export let groups
    export let active = false

    let fp          = null
    let file        = null
    let imported    = []
    let loading     = false
    let error       = false
    let dogmaImport = false

    const dispatch = createEventDispatcher()

    function removable(cookie) {
        return domain.domain === cookie.domain || !cookie.httpOnly
    }

    function readfiles(e) {
        file = fp.files[0]
        if(file.type !== 'application/json') {
            return cancelImport()
        }

        const reader = new FileReader()
        reader.addEventListener('load', event => {
            const text = event.target.result 
            const json = JSON.parse(text)
            if(json.every(item => item.ownedBy) /* exported by dogma */) {
                importDogmaFile(json)
            } else {
                imported = _.orderBy(JSON.parse(text), ['domain', 'name']).map(it => { delete it.value; return it})
            }
        })
        reader.readAsText(file)
    }

    function filterCookieOut(rm) {
        return it => {
            return !(it.name === rm.name && it.domain === rm.domain)
        }
    }

    function update(cookie) {
        let tmp = imported.filter(filterCookieOut(cookie))
        tmp = [...tmp, cookie]
        imported = _.orderBy(tmp, ['domain', 'name'])
    }

    function durationChanged(cookie) {
        // return e => {
        //     const value = _.trim(e.target.value)
        //     cookie.duration = value !== '' ? value : null
        //     update(cookie)
        // }
        return duration => {
            cookie.duration = duration
            update(cookie)
        }
    }

    function purposeChanged(cookie) {
        return e => {
            //console.log(cookie.name, e.target.value)  
            const value = _.trim(e.target.value)
            cookie.purpose = value !== '' ? value : null
            update(cookie)
        }
    }

    function groupChanged(cookie) {
        return option => {
            const group = groups.find(g => g.id === option.id)
            //console.log(cookie.name, group.name)    
            cookie.group = group
            update(cookie)
        }
    }

    function iconGiven(i) {
        if(i.dup) 
            return 'check inverted grey'
         else if(i.cookie.purpose && i.cookie.group && (i.cookie.session || i.cookie.duration)) 
            return 'green check'
         else if (i.cookie.purpose || i.cookie.group || i.cookie.duration) 
            return 'exclamation circle orange'
         else 
            return 'ban inverted grey'
        
    }

    function startImport() {
        active = true
        fp.click() 
    }

    function cancelImport() {
        active      = false
        error       = false
        imported    = []
        file        = null
        fp.value    = null
        dogmaImport = false
    }

    function importDogmaFile(json) {
        dogmaImport = true
        api
            .post("/donut/import", { domain: domain.id, groups: json })
            .then(api.toJsonIf200)
            .then(created => {
                dogmaImport = false
                dispatch('import', { groups: created })
                cancelImport()
            })
            .catch(err => {
                dogmaImport = false
                error       = `Erro importanto cookies: ${err.statusText}`
                setTimeout(() => {
                    cancelImport()
                }, 3000)
            })
    }

    function doImport() {
        
        const cookies = selectReady(list).map(it => { 
            const cookie    = it.cookie 
            cookie.group    = cookie.group.id
            cookie.duration = cookie.session ? 'session' : String(cookie.duration)
            cookie.kind     = "http"
            return cookie
        })
        
        // cookies.forEach(element => {
        //     console.log(element)
        // })

        loading = true
        api
            .post("/donut/import", { domain: domain.id, cookies })
            .then(api.toJsonIf200)
            .then(created => {
                loading = false
                dispatch('import', { cookies: created })
                cancelImport()
            })
            .catch(err => {
                loading = false
                console.log(err)
                error   = err
                setTimeout(() => {
                    error = false
                }, 3000)
            })
    }

    function computeOptions(groups) {
        return groups.map(g => {
            return {
                id: g.id,
                text: g.name
            }
        })
    }

    function selectedGroup(item) {
        const id = item.dup ? item.dup.group : item.cookie.group ? item.cookie.group.id : false
        //console.log(id, item.cookie.name)
        if(id) {
            return groupOptions.find(op => op.id === id)
        } else {
            return null
        }
    }

    function cookiesGiven(groups) {
        return _.flatten(groups.map(g => g.cookies))
    }

    function deduplicate(toBeImported, cookies) {
        return toBeImported.map(c => {
            return {
                cookie : c,
                dup    : cookies.find(it => it.name === c.name && it.domain === c.domain)
            }
        })
    }

    function selectReady(list) {
        return list.filter(it => {
            return !it.dup 
                && it.cookie.group 
                && it.cookie.purpose 
                && (it.cookie.session || it.cookie.duration)
        })
    }

    function durationGiven(d) {
        switch(d) {
            case "session"  : return "Sessão"
            case "unlimited": return "Permanente"          
        }

        return d

    }

    function exportCookies() {
        const text = JSON.stringify(groups)
        const blob = new Blob([ text ], { type : 'application/json; charset=utf-8' })
        files.default.saveAs(blob, 'exported-cookies.json')
    }

    $: groupOptions  = computeOptions(groups)
    $: cookies       = cookiesGiven(groups)
    $: list          = deduplicate(imported, cookies)
    $: readyToImport = selectReady(list).length
</script>

<style>
    .import {
        display: flex;
        justify-content: flex-end;
    }

    .import button {
        margin-left: 1em;
    }

    .import input[type="file"] {
        display: none;
    }

    .actions {
        display         : flex;
        flex-direction  : row-reverse;
        align-items     : baseline;
    }

</style>

<div class="import">
    <input type="file" bind:this={fp} on:change={readfiles} accept="application/json"/>
    <button class="ui blue left labeled icon button" 
            class:disabled={active} 
            on:click={ exportCookies }>
        <i class="upload icon"></i>Exportar Cookies
    </button>
    <button class="ui blue left labeled icon button" 
            class:disabled={active} 
            on:click={ startImport }>
        <i class="download icon"></i>Importar Cookies
    </button>
</div>

{#if imported.length > 0}
    <div class="ui segment" class:loading>
        <table class="ui padded large table">
            <thead>
                <tr>
                    <th class="three wide" >Nome     </th>
                    <th class="three wide" >Domínio  </th>
                    <th class="one wide"   >Path     </th>
                    <th class="three wide" >Validade </th>
                    <th class="four wide"  >Propósito</th>
                    <th class="two wide"   >Grupo    </th>
                    <th class="one wide"   >Estatus  </th>
                    <th class="one wide"   >Removível</th>
                </tr>
            </thead>
            <tfoot class="full-width">
                <tr>
                    <th colspan="8">
                        <div class="actions">
                            <button class="ui primary labeled icon button" 
                                    class:disabled={error || readyToImport === 0}
                                    on:click={ doImport }>
                                <i class="arrow alternate circle up icon"></i> 
                                    Importar {#if readyToImport > 0} { readyToImport } cookies {/if}
                            </button>
                            <button class="ui button" on:click={ cancelImport }>
                                Cancelar
                            </button>
                            {#if error}
                                <div transition:fade class="ui right floated red basic horizontal label">
                                    erro importando os cookies
                                </div>                                                    
                            {/if}
                        </div>
                    </th>
                </tr>
            </tfoot>        
            <tbody>
                {#each list as it (it.cookie.name)}
                    <tr>
                        <!-- <td>
                            <input type="checkbox" on:change={addRemove(cookie)}/>
                        </td>  -->
                        <td>{it.cookie.name}</td>
                        <td>{it.cookie.domain}</td>
                        <td>{it.cookie.path}</td>
                        <td>
                            {#if it.dup }
                                {durationGiven(it.dup.duration)}
                            {:else}
                                {#if it.cookie.session}
                                    Sessão
                                {:else}
                                    <!-- <span>[{it.cookie.duration}]</span>  -->
                                    <Duration onChange={durationChanged(it.cookie)} />
                                {/if}
                            {/if}
                        </td>
                        <td>
                            {#if it.dup }
                                {it.dup.purpose}
                            {:else}
                                <div class="ui fluid input">
                                    <input on:change={purposeChanged(it.cookie)} type="text">
                                </div>
                            {/if}
                        </td>
                        <td>
                            <Dropdown 
                                text="--" 
                                options={groupOptions} 
                                selected={selectedGroup(it)} 
                                onChange={groupChanged(it.cookie)}
                                disabled={it.dup}/>
                        </td>
                        <td>
                            <i class="{iconGiven(it)} icon"></i>
                        </td>
                        <td>
                            {#if removable(it.cookie)}
                                <!-- <span class="ui tiny green label">sim</span> -->
                                <i class="trash alternate outline green icon"></i>
                            {:else}
                                <i class="trash alternate outline inverted grey icon"></i>
                            {/if}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{:else if dogmaImport}
    <div class="ui icon message">
        <i class="notched circle loading icon"></i>
        <div class="content">
            <div class="header">
                Só um sergundo
            </div>
            <p>estamos importando seus grupos e cookies</p>
        </div>
    </div>
{:else if error}
    <div transition:fade class="ui negative icon message">
        <i class="bug icon"></i>
        <div class="content">
            <div class="header">
                Erro
            </div>
            <p>{error}</p>
        </div>
    </div>
{/if}
